import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../app/hooks/useAuth';
import Dashboard from '../app/pages/Dashboard';
import LoginPage from '../app/pages/LoginPage';
import AuthCallback from "../app/pages/AuthCallback";
import ProtectedRoute from './ProtectedRoute';
import AppLayout from '../layout/AppLayout';

const AppRoutes = () => {
  const { session, isLoading } = useAuth();
  
  // For logging/debugging
  console.log("AppRoutes render - Auth state:", { 
    hasSession: !!session, 
    isLoading 
  });
  
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute>
          <AppLayout>
            <Dashboard />
          </AppLayout>
        </ProtectedRoute>
      } />
      
      <Route path="/connect" element={
        // Only redirect if we definitively have a session and aren't loading
        (session && !isLoading) ? <Navigate to="/" replace /> : <LoginPage />
      } />
      
      <Route path="/auth/callback" element={<AuthCallback />} />
      
      {/* Catch-all route */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;

